import clsx from 'clsx';

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import { IoCheckmarkCircle } from 'react-icons/io5';
import { validateField } from '../utils/validation';
import OptinStep from './OptinStep';
import { useFidCardFunnelTracking } from '../../../../../posthog/funnelTrackingFidCard';
import { useEffect } from 'react';

const PhoneStep = ({
                     value,
                     onChange,
                     error,
                     setDialCode,
                     smsOptin = false,
                     onSmsOptinChange,
                   }) => {
  const handlePhoneChange = (phoneValue, country) => {
    setDialCode(country.dialCode);
    onChange(phoneValue);
  };

  const isValid = validateField('phone', value);

  const { trackPageViewCreatePhone } = useFidCardFunnelTracking();

  useEffect(() => {
    trackPageViewCreatePhone({});
  }, []);

  return (
    <div className="flex flex-col w-full appear">
      <div className="phone-input-container relative">
        <PhoneInput
          country="fr"
          countryCodeEditable={false}
          value={value}
          onChange={handlePhoneChange}
          placeholder="Numéro (ex: 06 06 06 06 06)"
          inputClass={clsx(
            '!w-full !h-20 !text-xl !pl-[72px] geomanistMedium !rounded-2xl',
            '!border-gray-200 geomanistMedium !bg-white',
            'shadow-[0px_6px_0px_0px_#e2e2e2]',
            'focus:!shadow-[0px_6px_0px_0px_#596802] focus:!border-[#596802]',
            {
              '!bg-[#ECED90] !shadow-[0px_6px_0px_0px_#596802] focus:!shadow-[0px_6px_0px_0px_#596802] focus:!border-[#596802] focus:!bg-[#ECED90]': isValid,
            },
          )}
          containerClass="!w-full !mb-0"
          buttonClass={clsx(
            '!rounded-l-2xl !border-0 !bg-white !border-gray-200',
            'hover:!bg-[#ECED90] !transition-all !duration-300',
            {
              '!bg-[#ECED90] !shadow-[0px_6px_0px_0px_#596802] focus:!shadow-[0px_6px_0px_0px_#596802] focus:!border-[#596802]': isValid,
            },
          )}
          dropdownClass="!bg-white !border !shadow-lg"
          searchClass="!bg-white !p-3 !border-b !border-gray-200"
          enableSearch
          searchPlaceholder="Rechercher un pays..."
          specialLabel=""
          inputProps={{
            required: true,
            autoComplete: 'tel',
            className: clsx(
              'shadow-[0px_6px_0px_0px_#e2e2e2]',
              'focus:!shadow-[0px_6px_0px_0px_#596802] focus:!border-[#596802]',
              '!border-gray-200 !rounded-2xl !h-20 !transition-all',
              '!pl-[42px] !text-2xl geomanistMedium !duration-300 !w-full',
              {
                '!border-[#FF2E6C]/50 !shadow-[0px_6px_0px_0px_#FF2E6C40]': error,
                '!pr-12 bg-[#ECED90] !shadow-[0px_6px_0px_0px_#596802] !border-[#596802] focus:!bg-[#ECED90]': isValid,
              },
            ),
          }}
        />

        {isValid && (
          <div className="absolute right-4 top-1/2 transform -translate-y-1/2 text-green-500 z-10">
            <IoCheckmarkCircle className="w-6 h-6" />
          </div>
        )}
      </div>

      {error && (
        <div className="flex items-center gap-2 px-3 py-2 bg-[#FFF0F5] rounded-lg border border-[#FF2E6C]/30 mt-6">
          <svg className="w-4 h-4 text-[#FF2E6C]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <title>Erreur</title>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span className="text-[#FF2E6C] text-xl geomanistMedium">{error}</span>
        </div>
      )}

      {/* Opt-in SMS */}
      <OptinStep
        showEmailOptin={false}
        showSmsOptin={true}
        smsOptin={smsOptin}
        onSmsOptinChange={onSmsOptinChange}
        className="mt-6"
      />

     
    </div>
  );
};

export default PhoneStep;
